import PropTypes from "prop-types";

function TableCellWithInnerSeparator({ value = "NA", cellType = "td", styles = {}, mainProps = {}, showSeperator = true }) {
    const { main: mainStyles = {}, wrapper: wrapperStyles = {}, value: valueStyles = {} } = styles;
    const Component = cellType === "th" ? "th" : "td";
    const isHeader = cellType === "th";

    const separatorClass = `table-seperator-col ${isHeader ? "table-seperator-head-height" : "table-seperator-row-height"}`;
    const cellClass = isHeader ? "table-head-cell" : "table-body-cell";

    return (
        <Component
            {...mainProps}
            style={mainStyles}
            scope={isHeader ? "col" : undefined}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    ...wrapperStyles,
                }}
            >
                <div
                    className={cellClass}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        ...valueStyles,
                        // whiteSpace: cellType !== "th" ? "nowrap" : "",
                    }}
                >
                    {showSeperator && <div className={separatorClass} />}
                    {value}
                </div>
            </div>
        </Component>
    );
}

TableCellWithInnerSeparator.propTypes = {
    value: PropTypes.node,
    styles: PropTypes.shape({
        main: PropTypes.object,
        wrapper: PropTypes.object,
        value: PropTypes.object,
    }),
    mainProps: PropTypes.object,
    cellType: PropTypes.oneOf(["td", "th"]),
    showSeperator: PropTypes.bool,
};

export default TableCellWithInnerSeparator;
